<div mat-dialog-title>
  <div class="customer-title">
    <h2>Customer Profile</h2>
    <div class="customer-actions">
      <button mat-button color="lightGreen" (click)="sendPrivateBroadcast()">
        Send Private Broadcast
      </button>
      <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
  </div>
</div>
<div class="customer-profile" mat-dialog-content>
  <div class="profile-columns">
    <div class="profile-column column-one">
      <div class="container customer-container">
        <div class="customer-image" [style]="customerImageStyle()" (click)="openImage()">
          <fa-icon *ngIf="image() === null" [icon]="faFileImage"></fa-icon>
        </div>
        <div class="customer-info">
          <div class="customer-heading">
            {{ customerName }}
          </div>
          <div class="customer-details">

            <div class="customer-detail">
              <div class="detail-heading">Gender:</div>
              <div class="detail-value">
                {{ customer.gender ? customer.gender : "-" }}
              </div>
            </div>

            <div class="customer-detail">
              <div class="detail-heading">Birthday:</div>
              <div class="detail-value">
                <ng-container *ngIf="customer.date_of_birth">
                  {{ formatDate(customer.date_of_birth) }} {{ age() }}
                </ng-container>
                <ng-container *ngIf="!customer.date_of_birth">-</ng-container>
              </div>
            </div>

            <div class="customer-detail">
              <div class="detail-heading">Company:</div>
              <div class="detail-value">
                {{ customer.company ? customer.company : "-" }}
              </div>
            </div>
            
            <div class="customer-detail">
              <div class="detail-heading">Email:</div>
              <div class="detail-value">
                {{ customer.email ? customer.email : "-" }}
              </div>
            </div>

            <div class="customer-detail">
              <div class="detail-heading">Created On:</div>
              <div class="detail-value">
                <ng-container *ngIf="customer.created_at">
                  {{ formatDate(customer.created_at) }}
                </ng-container>
                <ng-container *ngIf="!customer.created_at">-</ng-container>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="profile-column column-two">
      <div class="container membership-container">
        <div class="container-header no-bottom-border">
          <div class="text">Profile details</div>
        </div>
        <div class="container-content">

          <ng-container *ngIf="customFields?.length">
            <div *ngFor="let customField of customFields" class="details">
              <customer-profile-object [data]="customField"></customer-profile-object>
            </div>
          </ng-container>

          <div *ngIf="!customFields?.length" class="no-details">
            No fields defined
          </div>

        </div>
      </div>
      <div class="container lh-container">
        <div class="container-header no-bottom-border">
          <div class="text">LighthousePE details</div>
        </div>
        <div class="container-content">
          <div class="details">
            <div class="detail">
              <div class="key">Profile created:</div>
              <div class="value">
                <ng-container *ngIf="customer.created_at">
                  {{ formatDate(customer.created_at) }}
                </ng-container>
                <ng-container *ngIf="!customer.created_at">-</ng-container>
              </div>
            </div>
            <div class="detail">
              <div class="key">Currently on property?:</div>
              <div class="value">
                {{ customer.on_property ? "Yes" : "No" }}
              </div>
            </div>
            <div class="detail">
              <div class="key">Last on property:</div>
              <div class="value">
                <ng-container *ngIf="customer.last_on_property">
                  {{ formatDate(customer.last_on_property) }}
                </ng-container>
                <ng-container *ngIf="!customer.last_on_property"
                  >-</ng-container
                >
              </div>
            </div>
          </div>
          <div *ngFor="let device of devices" class="device">
            <div class="detail">
              <div class="key">Device:</div>
              <div class="value">{{ device.name ? device.name : "-" }}</div>
            </div>

            <div class="detail">
              <div class="key">Installed:</div>
              <div class="value">{{ formatDate(device.createdAt) }}</div>
            </div>

            <div class="detail">
              <div class="key">App version:</div>
              <div class="value">
                {{ device.appVersion ? device.appVersion : "-" }}
              </div>
            </div>

            <div class="detail">
              <div class="key">Location permission:</div>
              <div class="value">
                {{
                  device.locationPermission ? device.locationPermission : "-"
                }}
              </div>
            </div>
            <div class="detail">
              <div class="key">Notification permission:</div>
              <div class="value">
                {{
                  device.notificationPermission
                    ? device.notificationPermission
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="profile-column column-three">
      <div class="container comm-container">
        <div class="container-header no-bottom-border">
          <div class="text">Communication history</div>
        </div>
        <div class="container-content">
          <div
            *ngFor="let commHistory of communicationHistory"
            class="communication-history"
          >
            <div class="date">
              {{ commHistory.date }}
            </div>
            <div class="type">
              {{ commHistory.type }}
            </div>
            <div class="sent-time">sent {{ commHistory.sentTime }}</div>
          </div>
        </div>
      </div>
      <div class="container loc-container">
        <div class="container-header no-bottom-border">
          <div class="text">Location history</div>
        </div>
        <div class="container-content">
          <div
            *ngFor="let locHistory of locationHistory"
            class="location-history"
          >
            <div class="date">
              {{ locHistory.date }}
            </div>
            <div class="area">
              {{ locHistory.area }}
            </div>
            <div class="difference">{{ locHistory.difference }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>